import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { creatorListingsPath, productCreatorStagePath } from "@travily/routes";
import type ListingsCreatorPriceType from "@travily/types/pages/ListingsCreatorPriceType";
import { useCreatorTopBarActions } from "@/lib/wizard/use-creator-top-bar-actions";
import { useWizardForm } from "@/lib/wizard/use-wizard-form";
import { ProductPriceTypeStepView } from "./show.view";

type PageProps = ListingsCreatorPriceType;

type FormData = {
  price_type: "free" | "paid";
};

const ProductPriceTypeStep = ({ listing_id, stage_index, stage_order, price_type }: PageProps) => {
  const { form, currentStage, totalStages, onBack, onPrimary, primaryPending } = useWizardForm<FormData>({
    routes: {
      stageUrl: (stage) => productCreatorStagePath(listing_id, stage),
      entryUrl: creatorListingsPath(),
    },
    stageName: "price_type",
    stageIndex: stage_index,
    stageOrder: stage_order,
    initialData: { price_type: price_type === "paid" ? "paid" : "free" },
  });

  const topBarActions = useCreatorTopBarActions({ saveHref: creatorListingsPath() });

  return (
    <>
      <Head title={t("web.products.creator.steps.price_type.show.meta_title")}>
        <meta name="description" content={t("web.products.creator.steps.price_type.show.meta_description")} />
      </Head>
      <ProductPriceTypeStepView
        currentStage={currentStage}
        totalStages={totalStages}
        value={form.data.price_type}
        primaryPending={primaryPending}
        topBarActions={topBarActions}
        onBack={onBack}
        onPrimary={onPrimary}
        onChange={(value) => form.setData("price_type", value === "paid" ? "paid" : "free")}
      />
    </>
  );
};

export default ProductPriceTypeStep;
